<ng-container *ngIf="contactNote; else noContactNote">
  <div class="contact-note-container">
    <i class="material-icons warning-icon">warning_amber</i>
    <span>{{ contactNote }}</span>
  </div>
</ng-container>
<ng-template #noContactNote> </ng-template>
